export const locale = {
  lang: 'en',
  data: {
    'NOTIFICACIONES': {
      'INFO': {
        'HOY': 'Today',
        'TITUNOT': 'Notifications',
        'NOTTTIP': 'Mark as read'
      },
      'EDITOR_EMAILS': {
        'NUEVAMOD': 'The company <b>-ALVPRRO-</b> has made a modification to one or more of its communication emails',
        'NUEVAMODODS': 'A project manager has made changes to one or more communication emails for the company <b>-ALVPRRO-</b>'
      },
      'AUTORI-ENCUESTA': {
        'AUTORIZAR-ENCUESTA': 'The company <b>-ALVPRRO-</b> has sent to authorize the survey',
      },
    },
    'NOTIFICACION_PRODUCT':{
      'PRODUCTOS_ID':{
        '20':'Certify',
        '40':'Certificar 3.0',
        '41':'Medir 3.0',
        '42':'Pulsecheck 3.0',
        '43':'Focus Area ',
        '53':'Leader Go',
        '54':'Action Go',
        '56': 'AMCO',
        '57': 'Decent Work',
        '58':'First Job',
        '63':'NOM-035 v3.0',
      },
      'TIPO_MENSAJE_MOSTRAR':{
        'languageNative':'You have selected the main language',
        'sinAdicionales':'You have selected no additional languages',
        'languageAdittional':'You have selected the additional languages',
        'conAdicionales':'You have deselected the check without additional languages ',
        'deleteLangNative':'You have deleted the native language',
        'completePasLang':'You have completed the language step',
        'completePasTemplate':'You have completed the template step',
        'completePasReacti': 'You have completed the reagent step',
        'completePasNps': 'You have completed the nps step',
        'completePasControl': 'You have completed the control step',
        'completePasDemogra': 'You have completed the demographics step',
        'completePasAbierta': 'You have completed the open step',
        'completePasAdicio': 'You have completed the additional step',
        'completePas4all': 'You have completed the forall step',
        'completePasEncues': 'You have completed the survey step',
        'completePasColab': 'You have completed the collaborators step',
        'completePasEnvi': 'You have completed the sending step',
        'completePasEstat': 'You have completed the survey status step',
        'completePasProgra': 'You have completed the programming step',
        'DescompletePasLang': 'You have decompleted the language step',
        'DescompletePasTemplate': 'You have decompleted the template step',
        'DescompletePasReacti': 'You have uncompleted the reagent step',
        'DescompletePasNps': 'You have decompleted the nps step',
        'DescompletePasControl': 'You have decompleted the control step',
        'DescompletePasDemogra': 'You have uncompleted the demographics step',
        'DescompletePasAbierta': 'You have uncompleted the open step',
        'DescompletePasAdicio': 'You have uncompleted the additional step',
        'DescompletePas4all': 'You have uncompleted the forall step',
        'DescompletePasEncues': 'You have uncompleted the survey step',
        'DescompletePasColab': 'You have uncompleted the collaborators step',
        'DescompletePasEnvi': 'You have uncompleted the sending step',
        'DescompletePasEstat': 'You have uncompleted the survey status step',
        'DescompletePasProgra': 'You have uncompleted the programming step',
        'createSurvey': 'Survey has been created',
        'saveUserDemo': 'You have saved the demo users to the survey',
        'recreateSurvey': 'The survey has been recreated',
        'saveSeccionNps': 'The nps section has been saved to the survey',
        'saveSeccionReactivos': 'The reagents section has been saved to the survey',
        'saveSeccionControl': 'The control section has been saved to the survey',
        'saveSeccionDemogra': 'The demographic section has been saved to the survey',
        'saveSeccionAbier': 'The open section has been saved to the survey',
        'saveSeccionForall': 'Forall section has been saved to the survey',
        'saveSeccionAdicio': 'The additional section has been saved to the survey',
        'subBaseColab': 'The contributor base has been uploaded',
        'downloadBaseColab': 'The contributor base has been downloaded',
        'deleteBaseColab': 'The contributor base has been deleted',
        'saveUsersSurvey': 'The survey collaborators have been saved',
        'regisFechaLanza': 'The launch date of the survey has been recorded',
        'regisFechaAviso1': 'The date of notice 1 prior to the survey has been recorded',
        'regisFechaAviso2': 'The date of warning 2 prior to the survey has been recorded',
        'saveRecordatorioEncu': 'A reminder has been recorded',
        'enviarCorreos': 'You have selected to send mail to your collaborators',
        'noEnviarCorreos': 'You have selected not to send the mail to your collaborators',
        'cambiarEstatusCorreo': 'You have made the change to modify the sending of mail',
        'ActivaEstatEncu': 'The survey has been activated',
        'DesacEstatEncu': 'The survey has been deactivated',
        'activoSeccionNps':'The NPS section has been activated for the survey',
        'desActivoSeccionNps':'The NPS section has been deactivated for the survey',
        'activoSeccionReactivos':'The REACTIVE section has been activated for the survey',
        'desActivoSeccionReactivos':'The REACTIVOS section has been deactivated for the survey',
        'activoSeccionControl':'The CONTROL section has been activated for the survey',
        'desActivoSeccionControl':'The CONTROL section has been deactivated for the survey',
        'activoSeccionDemograficos':'The DEMOGRAPHICS section has been activated for the survey',
        'desActivoSeccionDemograficos':'The DEMOGRAPHICS section has been deactivated for the survey',
        'activoSeccionAbiertas':'The OPEN section has been activated for the survey',
        'desActivoSeccionAbiertas':'The section ABIERTAS para la encuesta has been deactivated',
        'activoSeccionForall':'The FORALL section has been activated for the survey',
        'desActivoSeccionForall':'The FORALL section has been deactivated for the survey',
        'activoSeccionAdicionales':'The ADDITIONAL section has been activated for the survey',
        'desActivoSeccionAdicionales':'The ADDITIONAL section has been deactivated for the survey',

        'deletePregTemNps':'The question has been deleted from the NPS section',
        'deletePregTemReacti':'The question has been deleted from the REACTIVES section',
        'deletePregTemControl':'The question has been deleted from the CONTROL section',
        'deletePregTemDemogra':'The question has been deleted from the DEMOGRAPHICS section',
        'deletePregTemAbier':'Question has been deleted from the OPEN section',
        'deletePregTemAdici':'The question has been deleted from the ADDITIONAL section',
        'savePregCatNps':'Catalog question has been saved to the NPS section',
        'savePregCatReacti':'The catalog question has been saved to the REAGENTS section',
        'savePregCatControl':'Catalog question has been saved to the CONTROL section',
        'savePregCatDemogra':'The catalog question has been saved to the DEMOGRAPHICS section',
        'savePregCatAbier':'Catalog question has been saved to the OPEN section',
        'savePregCatAdici':'Catalog question has been saved to the ADDITIONALS section',
        'savePregNueNps':'New question has been saved to the NPS section',
        'savePregNueReacti':'New question has been saved to the REAGENTS section',
        'savePregNueControl':'The new question has been saved to the CONTROL section',
        'savePregNueDemogra':'New question has been saved in the section DEMOGRAPHICS',
        'savePregNueAbier':'New question has been saved to the OPEN section',
        'savePregNueAdici':'New question has been saved to the ADDITIONALS section',
        'editPregNps':'The question has been edited in the NPS section',
        'editPregReacti':'Question in REAGENTS section has been edited',
        'editPregControl':'Question in CONTROL section has been edited',
        'editPregDemogra':'Question in the DEMOGRAPHICS section has been edited',
        'editPregAbier':'Question in the OPEN section has been edited',
        'editPregAdici':'Question in the ADDITIONAL section has been edited',
        'LogOut':'You are logged out',
        'reiniciarLang':'You have restarted the product',
        'accionText':'',
        'updatCuesForall':'The questionnaire of the forall section has been updated.',
        'savePracticaForall':'Practice forall has been saved',
        'saveDescripForall':'The description of the practice forall has been saved.',
        '':'',



      },
      'BTN_MOSTRAR_HISTO':'Show history',
      'ETI_PRODUC':'Product:',
      'TITLE_HISTO_PROD':'Product history',
      'CARG_INFOR':'Loading information',
      'TITLE_FILTER':'Filter: ',
      'DELETE_FILTER':'Delete filters',
      'FILTER_1':'Date:',
      'BUSCAR_FILTER':'Search',
      'TH_TITTLE':'Product History',
      'BTN_FILTER_HISTO':'Filter History',
      'TD_USUARIO':'User:',
      'TD_FECHA_PRODU':'Product date:',
      'TD_TIPO_PRODU':'Product type:',
      'TD_TIPO_USU_ADMI':'Administrator user',
      'WARNING_NO_DATOS':'No information to display',

    }
  }
};
